var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParaolympic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 24h30V0H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0282d",
    d: "M13.9 4.13c-1.58-.36-3.74.03-5.78 1.2-3.2 1.82-4.89 4.82-3.78 6.71.7 1.2 2.38 1.67 4.34 1.37-.9-.2-1.6-.65-2-1.33-1.11-1.89.58-4.9 3.78-6.71a10 10 0 0 1 3.44-1.24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a651",
    d: "M13.93 11.58c.48 1.54 1.9 3.18 3.95 4.35 3.19 1.81 6.67 1.76 7.78-.13.7-1.21.27-2.87-.97-4.4.27.87.24 1.7-.16 2.38-1.1 1.89-4.6 1.95-7.79.13a10 10 0 0 1-2.81-2.33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d0",
    d: "M11.76 7.87c-1.1 1.18-1.83 3.22-1.83 5.54 0 3.64 1.79 6.59 4 6.59 1.42 0 2.66-1.2 3.37-3.02a3 3 0 0 1-2.17 1.04c-2.2 0-4-2.94-4-6.58 0-1.31.23-2.54.63-3.57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParaolympic);
export default __webpack_public_path__ + "static/media/paraolympic.c86e889ef6ae918d1904f16b31046508.svg";
export { ForwardRef as ReactComponent };